import Module from './blogBanner'
export default Module
